import { colors, typography } from '@dixa/lib-shared-tokens';
import type { ITextStyle } from 'pixi.js';

import { textStyles } from '../../node/textStyles';
import { LINE_CAP } from '../../types/pixi';
import { blue, neutral, white } from '../common/colors';
import { styles as commonStyles } from '../common/commonStyles';

const base = {
  width: 250,
  height: 0,
  cornerRadius: 5,
};

const _content = {
  padding: 10,
  offset: textStyles.bitmapTextOffset,
  width:
    base.width -
    // L&R Padding
    10 * 2,
};

const _highlight = {
  size: 2,
};

const text: Partial<ITextStyle> = {
  ...commonStyles.text,
  fontSize: 16,
};

const italicText: Partial<ITextStyle> = {
  ...text,
  fontStyle: 'italic',
  fontWeight: typography.weight.normal as ITextStyle['fontWeight'],
};

/*
 * Head related content
 */
const head = {
  width: base.width,
  height: 32,
  fill: colors.neutral['100'],
};

const _headText = {
  position: {
    x: 42,
  },
};

const _deprecatedPill = {
  fill: blue['700'],
  padding: 8,
  height: 16,
  position: {
    x: 120,
    y: 8,
  },
};

const _deprecatedText = {
  ...textStyles.normal,
  tint: white,
  fontSize: 10,
};

const _typeIcon = {
  size: 16,
  anchor: {
    x: 0,
    y: 0.5,
  },
  position: {
    x: 16,
    y: head.height / 2,
  },
};

const _editIcon = {
  size: 16,
  anchor: {
    x: 0,
    y: 0.5,
  },
  position: {
    x: base.width - 26,
    y: head.height / 2,
  },
};

const _typeIndicator = {
  position: {
    x: 8,
    y: 6,
  },
  length: 20,
  size: 3,
  cap: LINE_CAP.ROUND,
};

const _port = {
  fill: white,
  border: neutral['400'],
  radius: 7 / 2,
  width: 2,
};

export const styles = {
  base,
  text,
  italicText,
  head,
  _content,
  _highlight,
  _deprecatedPill,
  _deprecatedText,
  _typeIndicator,
  _typeIcon,
  _headText,
  _editIcon,
  _port,
};
